import { useGeoLookupContext } from './useGeoLookupContext';

/**
 * Check is user's IP is from flaggedCountry (e.g US) and it's region is from a flagged list (e.g. ['TX', 'NY'])
 * @returns boolean
 */
export default function useIsFlaggedRegion(flaggedCountry = 'US', flaggedRegions = ['TX', 'NY']): boolean {
  const ctx = useGeoLookupContext();

  if (ctx != null) {
    const { country, region } = ctx;
    if (country === flaggedCountry && flaggedRegions.indexOf(region as string) >= 0) return true;
  }

  return false;
}
